import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HEFFALUMP, KOALA, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExStatusTag from 'visitor-ui-component-library/tag/VizExStatusTag';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import VizExListItemButton from 'visitor-ui-component-library/list/VizExListItemButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TheadListItemBreak = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__TheadListItemBreak",
  componentId: "sc-1kjmu8c-0"
})(["margin:0;background-color:", ";width:100%;height:1px;"], KOALA);
const TextWrapper = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__TextWrapper",
  componentId: "sc-1kjmu8c-1"
})(["flex-grow:1;min-width:0;padding-left:12px;"]);
const InfoText = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__InfoText",
  componentId: "sc-1kjmu8c-2"
})(["display:flex;justify-content:space-between;align-items:center;"]);
const NameText = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__NameText",
  componentId: "sc-1kjmu8c-3"
})(["font-weight:600;font-size:14px;color:", ";"], OBSIDIAN);
const TimestampText = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__TimestampText",
  componentId: "sc-1kjmu8c-4"
})(["font-size:12px;line-height:2;color:", ";"], HEFFALUMP);
const ItemWrapper = styled.div.withConfig({
  displayName: "ThreadListItemWrapper__ItemWrapper",
  componentId: "sc-1kjmu8c-5"
})(["text-align:left;display:flex;flex-direction:row;align-items:center;padding:16px;height:auto;.chat-head-avatar{height:40px !important;width:40px !important;}"]);
function ThreadListItemWrapper({
  nameText,
  onClick,
  renderAvatar,
  renderText,
  renderTimestamp,
  unseenCount
}) {
  const hasUnread = unseenCount > 0;
  return /*#__PURE__*/_jsxs(VizExListItemButton, {
    as: "button",
    role: "button",
    type: "button",
    "data-test-id": "thread-list-item",
    disablePadding: true,
    disableGutters: true,
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs(ItemWrapper, {
      children: [hasUnread ? /*#__PURE__*/_jsx(VizExStatusTag, {
        use: "info",
        className: "m-right-5"
      }) : null, renderAvatar(), /*#__PURE__*/_jsxs(TextWrapper, {
        children: [/*#__PURE__*/_jsxs(InfoText, {
          as: VizExSmall,
          use: "help",
          children: [/*#__PURE__*/_jsx(NameText, {
            "data-test-id": "thread-list-item-name-text",
            children: nameText
          }), /*#__PURE__*/_jsx(TimestampText, {
            children: renderTimestamp()
          })]
        }), renderText()]
      })]
    }), /*#__PURE__*/_jsx(TheadListItemBreak, {})]
  });
}
ThreadListItemWrapper.displayName = 'ThreadListItemWrapper';
ThreadListItemWrapper.propTypes = {
  nameText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  renderAvatar: PropTypes.func.isRequired,
  renderText: PropTypes.func.isRequired,
  renderTimestamp: PropTypes.func.isRequired,
  unseenCount: PropTypes.number
};
export default ThreadListItemWrapper;